import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function DateLessThanOrEqualsValidator(compareDate = new Date()): ValidatorFn {
  return function DateLessThanOrEqualsValidate(control: AbstractControl): ValidationErrors {
    if (!control.value) { return null; }
    const date1 = new Date(control.value);

    if (compareDate !== null && date1 < compareDate) {
      return {
        'date_less_than_or_equal': true
      };
    }
    return null;
  };
}
